import React from 'react';
import { Link } from 'react-router-dom'

const Breadcrumb = (props) => {
    return (
        <>
            <div className="site-breadcrumb">
                <div className="container">
                    <h2 className="breadcrumb-title">{props.pagename}</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li className="active">{props.pagename}</li>
                    </ul>
                </div>
                {/* <div className="hero-shape">
              <img className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
              <img className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
              <img className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
              <img className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
            </div> */}
            </div>
        </>
    )
}

export default Breadcrumb
